import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { RequestTypes } from '../../../models/enums/request-types.enum';
import { HttpService } from './../http.service';
import { HttpConfiguration } from '../../../app.http.config';

@Injectable()
export class AccountPageHttpService extends HttpService {
    constructor(httpConfig: HttpConfiguration, http: HttpClient) {
        super('api/accountPage/', RequestTypes.InternalApi, httpConfig, http);
    }

    public getCurrentUserInfo(): Observable<any> {
        return this.get('getUserInfo', null).pipe();
    }

    public getUserInfo(email: string): Observable<any> {
        return this.get(`getUserInfo/${email}`, null).pipe();
    }

    public postChangeAddress(contactInfoViewModel: any): Observable<any> {
        return this.post('postChangeAddress', contactInfoViewModel).pipe();
    }

    /** get full client information */
    public getClientInfo(): Observable<any> {
        return this.get('getClientInfo', null).pipe();
    }

    public postChangeClientInfo(model: any): Observable<any> {
        return this.post('postChangeClientInfo', model).pipe();
    }

    public postChangeClientFullInfo(model: any): Observable<any> {
        return this.post('postChangeClientFullInfo', model).pipe();
    }

    public getUserCommonInfo(): Observable<any> {
        return this.post('getUserCommonInfo', null).pipe();
    }

    public getPaymentInfo(): Observable<any> {
        return this.post('getPaymentInfo', null).pipe();
    }

    public changePaymentInfo(model: any): Observable<any> {
        return this.post('changePaymentInfo', model).pipe();
    }

    public validatePassword(model: any): Observable<any> {
        return this.post('validatePassword', model).pipe();
    }

    public changePassword(model: any): Observable<any> {
        return this.post('changePassword', model).pipe();
    }

    public updateAccount(model: any): Observable<any> {
        return this.post('updateAccount', model).pipe();
    }

    public updateAddress(model: any): Observable<any> {
        return this.post('updateAddress', model).pipe();
    }
}


// WEBPACK FOOTER //
// ./src/app/core/http/internal/accountpage.http.service.ts